// @ts-nocheck
import React, { useEffect } from 'react';
import { Button, Spinner } from '@blueprintjs/core';
import { useCatalogItemSelection } from './CatalogItemSelectionProvider';

export default function CatalogCredentialsMissing() {
  const { providerConfig, setCredentialsDialogOpen, refetchCredentials, usersFetching } = useCatalogItemSelection();

  useEffect(() => {
    refetchCredentials?.();
  }, [refetchCredentials]);

  return (
    <div className="catalog-selection__no-credentials">
      <p>You will need to add your {providerConfig.label} Credentials to search {providerConfig.label} products</p>
      <Button className='add-credentials-btn' onClick={() => setCredentialsDialogOpen(true)}>
        Add {providerConfig.label} Credentials
      </Button>
      <Button outlined disabled={!!usersFetching} onClick={() => refetchCredentials?.()} style={{ marginTop: 8 }}>
        {usersFetching ? <Spinner size={14} /> : 'I added credentials'}
      </Button>
    </div>
  );
}
